import { formatCurrency } from './helpers';

declare const Chart: any;

export function renderRevenueChart(canvasId: string, data: Array<{ month: string; total: number }>) {
  const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
  if (!canvas || typeof Chart === 'undefined') return;

  const ctx = canvas.getContext('2d')!;
  const sorted = [...data].reverse();
  const labels = sorted.map(d => d.month);
  const values = sorted.map(d => d.total);

  // Gradient fill
  const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
  gradient.addColorStop(0, 'rgba(45, 184, 127, 0.3)');
  gradient.addColorStop(1, 'rgba(45, 184, 127, 0.01)');

  new Chart(ctx, {
    type: 'line',
    data: {
      labels,
      datasets: [{
        label: 'Revenue',
        data: values,
        borderColor: '#2DB87F',
        backgroundColor: gradient,
        fill: true,
        tension: 0.35,
        pointBackgroundColor: '#2DB87F',
        pointBorderColor: '#2DB87F',
        pointRadius: 4,
        pointHoverRadius: 6,
        borderWidth: 2,
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: '#FFFFFF',
          titleColor: '#1A1A1A',
          bodyColor: '#6B6B6B',
          borderColor: '#E8E7E3',
          borderWidth: 1,
          padding: 12,
          callbacks: {
            label: (ctx: any) => formatCurrency(ctx.parsed.y),
          }
        }
      },
      scales: {
        x: {
          grid: { color: 'rgba(0,0,0,0.06)' },
          ticks: { color: '#9B9B9B', font: { size: 11 } }
        },
        y: {
          grid: { color: 'rgba(0,0,0,0.06)' },
          ticks: {
            color: '#9B9B9B',
            font: { size: 11 },
            callback: (v: number) => '$' + (v >= 1000 ? (v / 1000).toFixed(0) + 'k' : v)
          }
        }
      }
    }
  });
}
